import { render, staticRenderFns } from "./Variation.vue?vue&type=template&id=bdf9dee8&"
import script from "./Variation.vue?vue&type=script&lang=js&"
export * from "./Variation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf9dee8')) {
      api.createRecord('bdf9dee8', component.options)
    } else {
      api.reload('bdf9dee8', component.options)
    }
    module.hot.accept("./Variation.vue?vue&type=template&id=bdf9dee8&", function () {
      api.rerender('bdf9dee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/variation/Variation.vue"
export default component.exports